import { Sorting, WithSearch, SearchBox } from '@elastic/react-search-ui';
import { CustomSelect } from './CustomSelect';
const getRandomSortList = () => {
  return [{ field: 'porsche_image_boost', direction: 'desc' as const }];
};
const randomSortList = getRandomSortList();
const lowToHigh = [
  { field: 'porsche_price_boost', direction: 'desc' as const },
  { field: 'listing_price_value', direction: 'asc' as const },
];

const FILTER_FIELD_LABELS: Record<string, string> = {
  listing_model_generation_txt: 'TYPE',
  listing_body_type_txt: 'BODY',
  listing_transmission_txt: 'TRANS',
  listing_grouped_base_color: 'EXT',
  listing_grouped_exterior_color: 'EXT',
  listing_interior_base_color: 'INT',
  listing_build: 'BUILD',
  listing_road_legal: 'REG',
  listing_classic_car: 'H',
  listing_already_sold: 'STATUS',
  listing_expert_appraisal: 'APPRAISAL',
  listing_pab_variant_txt: 'VARIANT',
  listing_country_code_txt: 'COUNTRY',
  listing_homologation_txt: 'HOMOL',
};

export const SearchRow: React.FC = () => {
  return (
    <WithSearch
      mapContextToProps={({ searchTerm, setSearchTerm, filters, removeFilter, clearFilters, resultsPerPage, setResultsPerPage }) => ({
        searchTerm,
        setSearchTerm,
        filters,
        removeFilter,
        clearFilters,
        resultsPerPage,
        setResultsPerPage,
      })}
    >
      {({ searchTerm, setSearchTerm, filters, removeFilter, clearFilters, resultsPerPage, setResultsPerPage }) => {
        const activeFilters = (filters || []).filter(
          (f: any) => f.type !== 'range' && f.values && f.values.length > 0
            && !['listing_production_year', 'listing_price_value', 'listing_mileage_value', 'listing_ps', 'listing_make_txt'].includes(f.field)
        );

        return (
          <div className="flex flex-col gap-3 pr-6 pt-3 pb-6 w-full">
            {/* Main row: search + sort + per-page */}
            <div className="flex gap-3 items-center">
              {/* Search input */}
              <div className="flex-1">
                <div className="flex w-full items-stretch border border-mp-border bg-mp-surface focus-within:border-primary transition-colors h-8">
                  <input
                    className="flex w-full min-w-0 flex-1 resize-none overflow-hidden text-mp-text focus:outline-0 focus:ring-0 border-none bg-transparent placeholder:text-mp-muted px-3 text-sm font-mono leading-normal"
                    spellCheck="false"
                    placeholder="> Enter specifications..."
                    value={searchTerm || ''}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Escape') setSearchTerm('');
                    }}
                  />
                  {searchTerm && (
                    <div className="flex items-center justify-center bg-transparent pr-3">
                      <button
                        className="flex items-center justify-center text-mp-muted hover:text-primary transition-colors cursor-pointer"
                        onClick={() => setSearchTerm('')}
                      >
                        <span className="material-symbols-outlined text-sm">close</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Sort dropdown */}
              <div className="relative min-w-[140px] h-8">
                <Sorting
                  label=""
                  sortOptions={[
                    { name: 'Relevance', value: randomSortList, direction: undefined },
                    { name: 'Price ↑', value: lowToHigh, direction: undefined },
                    { name: 'Price ↓', value: 'listing_price_value', direction: 'desc' },
                  ]}
                  view={({ onChange, value, options }) => (
                    <CustomSelect 
                      value={value} 
                      options={options} 
                      onChange={onChange} 
                    />
                  )}
                />
              </div>

              {/* Per-page */}
              <div className="relative min-w-[70px] h-8">
                <CustomSelect
                  value={resultsPerPage || 12}
                  options={[
                    { label: '12', value: 12 },
                    { label: '24', value: 24 },
                    { label: '48', value: 48 },
                    { label: '96', value: 96 }
                  ]}
                  onChange={(val: number) => setResultsPerPage(val)}
                  align="right"
                />
              </div>
            </div>

            {/* Filter chips row */}
            {activeFilters.length > 0 && (
              <div className="flex gap-2 flex-wrap items-center">
                {activeFilters.map((filter: any) =>
                  filter.values.map((value: any, idx: number) => (
                    <div
                      key={`${filter.field}-${idx}`}
                      className="flex h-6 shrink-0 items-center justify-center gap-x-1 border border-mp-muted bg-mp-surface px-2 hover:border-primary cursor-pointer transition-colors group"
                      onClick={() => removeFilter(filter.field, value)}
                    >
                      <p className="text-mp-text text-xs font-mono leading-normal uppercase">
                        {FILTER_FIELD_LABELS[filter.field] ? `${FILTER_FIELD_LABELS[filter.field]}:` : ''}{String(value)}
                      </p>
                      <span className="material-symbols-outlined text-[14px] text-mp-muted group-hover:text-primary">close</span>
                    </div>
                  ))
                )}
                <button
                  className="text-mp-muted text-xs font-mono hover:text-mp-text ml-2"
                  onClick={() => clearFilters()}
                >
                  CLEAR ALL
                </button>
              </div>
            )}
          </div>
        );
      }}
    </WithSearch>
  );
};
